<div id="{{ chartId }}" style="width: 100%" [ngStyle]="{ height: chartHeight }"></div>
